
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import TableContainer from '@material-ui/core/TableContainer';
import { ResponsiveTable } from 'ui/Table';
import Highlighter from "react-highlight-words";

import { DateTimeDisplay } from 'core/Display';


export default class ScheduleTableISelectItems extends Component {

  disableClickEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const { items, loading, onSelect, searchWords, selected } = this.props;

    return (
      <TableContainer>
        <ResponsiveTable>
          <TableHead>
            <TableRow>
              <TableCell component="th" scope="row">ТС</TableCell>
              <TableCell component="th" scope="row">Водитель</TableCell>
              <TableCell component="th" scope="row">Полуприцеп</TableCell>
              <TableCell component="th" scope="row" style={{whiteSpace: 'nowrap'}}>Дата начала</TableCell>
              <TableCell component="th" scope="row" style={{whiteSpace: 'nowrap'}}>Дата окончания</TableCell>
              <TableCell component="th" scope="row" style={{whiteSpace: 'nowrap'}}>Максимальный вес</TableCell>
              <TableCell component="th" scope="row">Комментарий</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={7}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            )}
            {items.map(item => {
              return (
                <TableRow
                  key={item.start_slot.id}
                  hover={true}
                  className={'pointer'}
                  selected={selected ? item.start_slot.id === selected.id : false}
                  onClick={(event) => onSelect(item)}
                  style={{backgroundColor: item.slot_color}}
                >
                  <TableCell>
                    {item.start_slot.tractor_unit && (
                      <React.Fragment>
                        <Highlighter
                          searchWords={searchWords}
                          textToHighlight={item.start_slot.tractor_unit.number}
                        />
                        <br/>
                        <span className={'text-gray'}>
                          <Highlighter
                            searchWords={searchWords}
                            textToHighlight={[item.start_slot.tractor_unit.type.label, item.start_slot.tractor_unit.year && `(${item.start_slot.tractor_unit.year})`].filter(Boolean).join(' ')}
                          />
                        </span>
                      </React.Fragment>
                    )}
                    {!item.start_slot.tractor_unit && '-'}
                  </TableCell>
                  <TableCell>
                    {item.start_slot.driver && (
                      <Highlighter
                        searchWords={searchWords}
                        textToHighlight={item.start_slot.driver.short_name}
                      />
                    )}
                    {!item.start_slot.driver && '-'}
                  </TableCell>
                  <TableCell>
                    {item.start_slot.semi_trailer && (
                      <React.Fragment>
                        <Highlighter
                          searchWords={searchWords}
                          textToHighlight={item.start_slot.semi_trailer.number}
                        />
                        <br/>
                        <span className={'text-gray'}>
                          <Highlighter
                            searchWords={searchWords}
                            textToHighlight={[item.start_slot.semi_trailer.type.label, item.start_slot.semi_trailer.year && `(${item.start_slot.semi_trailer.year})`].filter(Boolean).join(' ')}
                          />
                        </span>
                      </React.Fragment>
                    )}
                    {!item.start_slot.semi_trailer && '-'}
                  </TableCell>
                  <TableCell style={{whiteSpace: 'nowrap'}}>
                    <DateTimeDisplay value={item.start_slot.date_start} />
                  </TableCell>
                  <TableCell style={{whiteSpace: 'nowrap'}}>
                    <DateTimeDisplay value={item.end_slot.date_end} />
                  </TableCell>
                  <TableCell>
                    {item.start_slot.schedule_max_weight || '-'}
                  </TableCell>
                  <TableCell>
                    {item.start_slot.comment && (
                      <Highlighter
                        searchWords={searchWords}
                        textToHighlight={item.start_slot.comment}
                      />
                    )}
                  </TableCell>
                </TableRow>
              )
            })}
            {(!loading && items.length === 0) && (
              <TableRow>
                <TableCell colSpan={6}>Ничего не найдено</TableCell>
              </TableRow>
            )}
          </TableBody>
        </ResponsiveTable>
      </TableContainer>
    )
  }
}
